import type { QuizMeta } from "@/schema/quizSchema";
import { Testimonial } from "@/components/Testimonial";

/**
 * Landing hero shown above the FIRST question. Renders the quiz's intro headline
 * + body and an optional social-proof testimonial, turning the opening question
 * screen into a committing landing. Opt-in: QuizWidget renders this only when the
 * quiz declares `meta.testimonial`, so quizzes without one are unchanged.
 */
export function Hero({ meta }: { meta: QuizMeta }) {
  return (
    <div className="qk-hero" data-qk-hero>
      <h1 className="qk-hero-title">{meta.introHeadline}</h1>
      {meta.introBody && <p className="qk-hero-body">{meta.introBody}</p>}
      {meta.testimonial && <Testimonial data={meta.testimonial} />}
    </div>
  );
}
